/**
 * The Enterprise Dashboard & Inbox route (FSD Part 1 overview).
 *
 * `/enterprise` replaces the legacy `/settings/organization/go-live` checklist
 * screen: the configuration-completeness widget here renders the same
 * `GET /go-live-checklist` data. The redirect from the legacy path, the router
 * spread and the nav entry belong to the integration step, which owns
 * `web/src/router/**` and `web/src/nav/**`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { OVERVIEW_PERMISSIONS } from '@/modules/enterprise/overview/permissions'
import type { StructureRegister } from '@/modules/enterprise/overview/api'

export const ENTERPRISE_OVERVIEW_PATH = '/enterprise'

export function enterpriseOverviewRoute(): string {
  return ENTERPRISE_OVERVIEW_PATH
}

/** Where each structure counter links: the register screen for that object. */
export const REGISTER_ROUTES: Record<StructureRegister, string> = {
  legalEntities: '/enterprise/legal-entities',
  divisions: '/enterprise/divisions',
  businessUnits: '/enterprise/business-units',
  costCentres: '/enterprise/divisions/cost-centres',
  positions: '/settings/organization/positions',
  ledgers: '/enterprise/ledgers',
}

export const APPROVALS_INBOX_PATH = '/approvals'
export const ATTENTION_PATH = '/attention'
export const AUDIT_EXPLORER_PATH = '/audit'

export const ENTERPRISE_OVERVIEW_ROUTES: RouteRecordRaw[] = [
  {
    path: ENTERPRISE_OVERVIEW_PATH,
    name: 'enterprise-overview',
    component: () => import('@/modules/enterprise/overview/EnterpriseOverviewView.vue'),
    meta: {
      titleKey: 'enterprise.overview.routeTitles.overview',
      permission: OVERVIEW_PERMISSIONS.read,
    },
  },
]
